import {
  MenuItemInInventory,
  RatePlanDetailsForEachDate
} from '../../../types/inventory'
import RenderRowValues from '../renderRows/RenderRowValues'
import useStyles from './styles/InventoryRatePlanRowMobile.styles'

interface InventoryRatePlanRowProps {
  ratePlanData: RatePlanDetailsForEachDate[]
  hideZeroes: boolean
  occupancy: number | 'def'
  selectedInventoryFieldInRatePlan: MenuItemInInventory
  weekendIndexes: number[]
  defaultOccupancy: number
}

const InventoryRatePlanRow: React.FC<InventoryRatePlanRowProps> = ({
  ratePlanData,
  hideZeroes,
  occupancy,
  selectedInventoryFieldInRatePlan,
  weekendIndexes,
  defaultOccupancy
  //   weekendIndexes,
  //   numberOfRatePlans,
  //   showRatePlans,
  //   setshowRatePlans
}) => {
  const classes = useStyles()

  return (
    <div className={classes.roomTypeRow}>
      {/* <div className={classes.rowNameContainer}>
        <Typography variant="h4" className={classes.rowName}>
          {getTranslate(name)}
        </Typography>

        <ArrowRightIcon className={[classes.channelArrowRight].join(' ')} />
      </div> */}
      {/* <div className={classes.dayContainer}>
          <Typography variant="h5">{getTranslate('AVAIL')}</Typography>
        </div> */}
      <div className={classes.avalabilitiesContainer}>
        <div className={classes.dayContainer} />
        <RenderRowValues
          defaultOccupancy={defaultOccupancy}
          rowData={ratePlanData}
          hideZeroes={hideZeroes}
          occupancy={occupancy}
          selectedInventoryField={selectedInventoryFieldInRatePlan}
          weekendIndexes={weekendIndexes}

          // onSaveRowData={(newRowData) => {
          //   onSaveRowData(newRowData as InventoryRateplanType)
          // }}
        />
      </div>
    </div>
  )
}

export default InventoryRatePlanRow
